import { useContext, useEffect, useState } from "react";
import ContentPage from "../../Content";
import moment from "moment";
import BaseUrl from "../../../utils/BaseUrl";
import axios from "axios";
import separateNumber from "../../../utils/separateur";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";
import { useNavigate } from "react-router-dom";
import SwalTopEnd from "../../../utils/swal_top_end";
import PageHeader from "../../ui/PageHeader";
import SectionCard from "../../ui/SectionCard";
import SearchBox from "../../ui/SearchBox";
import EmptyState from "../../ui/EmptyState";

const url = BaseUrl();
function Approvisionnement(){
    const [dateTime,setDateTime] = useState(new Date()) ;
    const [itemsList,setItemsList] = useState([]);
    const [itemsListFilter,setItemsListFilter] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dateDebut,setDateDebut] = useState('');
    const [dateFin,setDateFin] = useState('');

    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PAGE APPROVISIONNEMENT')){
          navigate('/page-no-found');
      }
    },[user]);

    useEffect(()=>{
        fetchData(dateTime);
    },[]);

    const fetchData = async (date_debut,date_fin) => {
        // Un des deux bornes est vide/invalide (ex: date de fin choisie avant la date de
        // début) : on refuse d'envoyer "Invalid date" au backend, ce qui élargirait
        // la requête à tout l'historique et pouvait renvoyer une réponse JSON énorme
        // (et tronquée côté réseau -> "SyntaxError: JSON.parse: unterminated string").
        if (!moment(date_debut).isValid() || !moment(date_fin).isValid()) {
            SwalTopEnd({icon:'error', title:'Veuillez sélectionner une date de début et une date de fin'});
            return;
        }

        try {
            setLoading(true);
            const response = await axios.post(url.base+'/approvisionnements',{date_debut:moment(date_debut).format('YYYY-MM-DD'),date_fin:moment(date_fin).format('YYYY-MM-DD')},{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`

                }});
            const data = response.data.data;

            // Transforme les données pour utiliser le nom comme clé et ajoute la somme des ventes
            const transformedData = {};
            Object.values(data).forEach((sales) => {
                sales.forEach((sale) => {
                    const sellerName = sale.NomCommercial || 'Inconnu';
                    if (!transformedData[sellerName]) {
                        transformedData[sellerName] = {
                            sales: [],
                            totalSales: 0,
                        };
                    }
                    transformedData[sellerName].sales.push(sale);
                    transformedData[sellerName].totalSales += sale.Montant;
                });
            });

            setItemsList(transformedData);
            setItemsListFilter(transformedData);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            SwalTopEnd({icon:'error', title:'Erreur lors du chargement des approvisionnements. Réessayez avec une période plus courte.'});
        }
    };

    const sortedData = Object.entries(itemsListFilter).sort(
        ([, a], [, b]) => b.totalSales - a.totalSales
      );


    const handleFilter = (event) => {
        const searchValue = event.target.value.toLowerCase();
        const filtered = Object.keys(itemsList).reduce((result, sellerName) => {
          if (sellerName.toLowerCase().includes(searchValue)) {
            result[sellerName] = itemsList[sellerName];
          }
          return result;
        }, {});

        setItemsListFilter(filtered);
      };

      const handleFilterDate=(event)=>{
        const dateValue = event.target.value;
        if(event.target.value !== ""){
            setDateTime(dateValue);
            setDateFin(dateValue)
            fetchData(dateDebut,dateValue);
        }


      }

    const periodeLabel = dateFin === ''
        ? moment(dateTime).format('DD MMMM YYYY')
        : `${moment(dateDebut).format('DD MMM YYYY')} au ${moment(dateFin).format('DD MMM YYYY')}`;

    return (
        <>
            <ContentPage>
              <PageHeader eyebrow="Commerciaux" title="Approvisionnements" periodLabel={periodeLabel} />

              <div className="col-lg-12 grid-margin stretch-card">
                <SectionCard icon="mdi-truck-delivery" color="gold" title="Approvisionnements par commercial">
                    <div className="filter-toolbar mb-4">
                      <div className="row g-3">
                        <div className="col-lg-4 col-md-6">
                          <label className="filter-field-label">Rechercher</label>
                          <SearchBox placeholder="Rechercher un commercial..." onChange={handleFilter} />
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <label className="filter-field-label">Date de début</label>
                          <input type="date" className="form-control" onChange={(e)=>setDateDebut(e.target.value)}/>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <label className="filter-field-label">Date de fin</label>
                          <input type="date" className="form-control" onChange={handleFilterDate}/>
                        </div>
                      </div>
                    </div>

                    {loading && (
                      <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status"></div>
                      </div>
                    )}

                    {!loading && sortedData.length === 0 && (
                      <EmptyState icon="mdi-account-search-outline" title="Aucun commercial trouvé" subtitle="Essayez une autre période ou un autre nom." />
                    )}

                    {!loading && sortedData.length > 0 && (
                      <div className="accordion appro-accordion" id="accordionExample">
                        {sortedData.map(([sellerName, sellerData], order) => (
                          <div className="accordion-item mb-2" key={sellerName}>
                            <h2 className="accordion-header" id={`headingOne${order+1}`}>
                              <button className="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${order+1}`} aria-expanded="false" aria-controls={`collapseOne${order+1}`}>
                                <span className="soft-badge variant-gold me-2">{order+1}</span>
                                <span className="flex-grow-1">{sellerName}</span>
                                <span className="soft-badge variant-success me-3" style={{fontSize:'0.95rem'}}>
                                  {separateNumber(sellerData.totalSales)} FCFA
                                </span>
                              </button>
                            </h2>
                            <div id={`collapseOne${order+1}`} className="accordion-collapse collapse" aria-labelledby={`headingOne${order+1}`} data-bs-parent="#accordionExample">
                              <div className="accordion-body">
                                <div className="table-responsive">
                                  <table className="table table-striped align-middle">
                                    <thead>
                                      <tr>
                                        <th>ID</th>
                                        <th>DATE</th>
                                        <th>TERRITOIRE</th>
                                        <th>SECTEUR</th>
                                        <th className="text-center">PRODUIT</th>
                                        <th className="text-center">MONTANT</th>
                                        <th>N° MARCHAND POS</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {sellerData.sales.map((vente, index) => (
                                        <tr key={index}>
                                          <td className="py-1">
                                            <img src="../../../assets/images/faces-clipart/pic-1.png" alt="" className="rounded-circle" style={{width:28,height:28}} />
                                          </td>
                                          <td>{moment(vente.DateVente).format('Do MMMM YYYY')}</td>
                                          <td>{vente.NomTerritoire}</td>
                                          <td>{vente.NomSecteur}</td>
                                          <td className="text-center">{vente.NomProduit}</td>
                                          <td className="text-center">
                                            <b className={vente.Montant > 100000 ? "text-danger" : "text-success"}>{separateNumber(vente.Montant)}</b>
                                          </td>
                                          <td>{vente.NumeroMarchandPOS}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                </SectionCard>
              </div>
            </ContentPage>
        </>
    )
}

export default Approvisionnement;
